import Product from './components';

export default Product;
